import { getTheme, mergeStyles } from '@fluentui/react';
import { TooltipText } from 'components/shared/TooltipText';
import React from 'react';
import { TableContentNode } from '../JsonContent';
import { empty } from '../JsonFrame';
import { JsonContentValidationMessage } from './JsonContentValidationMessage';

interface TableTypeProps {
  val: TableContentNode[];
  focusText: string;
  isZoomInActive?: boolean;
}

export const TableType: React.FunctionComponent<TableTypeProps> = (props): JSX.Element => {
  const { palette } = getTheme();
  // Renders Cells of a Row
  const renderCells = (row: TableContentNode, focusText: string): JSX.Element[] => {
    const td: JSX.Element[] = [];

    Object.keys(row).forEach(col => {
      const colVal = row[col];
      const isWrongValue = empty(colVal);
      // Special rule for Mixer chat scenario
      // Style the cell of the reported message by comparing to the text value in subjectHashes
      // The cell value comes with a leading and trailing '***', account for such
      if (focusText !== undefined && '***' + focusText + '***' === colVal) {
        td.push(
          <td style={{ border: '1px solid', borderColor: palette.black }}>
            <br />
            {!isWrongValue ? (
              <b>{colVal}</b>
            ) : (
              <JsonContentValidationMessage message={TooltipText.tableTypeCellValidationMessage} />
            )}
            <br />
            <br />
          </td>
        );
      } else {
        td.push(
          <td style={{ border: '1px solid', borderColor: palette.black }}>
            {!isWrongValue ? (
              colVal
            ) : (
              <JsonContentValidationMessage message={TooltipText.tableTypeCellValidationMessage} />
            )}
          </td>
        );
      }
    });

    return td;
  };

  // Renders rows within a table
  const renderRows = (rows: TableContentNode[], focusText: string): JSX.Element[] => {
    const div: JSX.Element[] = [];

    let rowCount = 1;
    rows.forEach(row => {
      if (rowCount === 1) {
        div.push(
          <thead style={{ backgroundColor: palette.neutralLight }}>
            <tr>{renderCells(row, focusText)}</tr>
          </thead>
        );
      } else {
        div.push(
          <tbody>
            <tr
              id={
                Object.keys(row).some(e => focusText !== undefined && '***' + focusText + '***' === row[e])
                  ? 'reportedText'
                  : ''
              }
            >
              {renderCells(row, focusText)}
            </tr>
          </tbody>
        );
      }
      rowCount++;
    });
    return div;
  };

  const isWrongValue = empty(props.val) ? true : false;
  const tableValidationMessageClass = mergeStyles(
    {
      minHeight: props.isZoomInActive ? 500 : ''
    },
    'mx-3 mt-3'
  );

  return (
    <div className={props.isZoomInActive ? 'pt-3' : ''}>
      {!isWrongValue ? (
        <table className={props.isZoomInActive ? 'contentTable mx-3' : 'contentTable'} cellPadding="4">
          {renderRows(props.val, props.focusText)}
        </table>
      ) : (
        <JsonContentValidationMessage
          message={TooltipText.tableTypeValidationMessage}
          validationMessageWrapperClass={tableValidationMessageClass}
        />
      )}
    </div>
  );
};
